import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';

const baseUrl = `${environment.domain}`;
@Injectable({
  providedIn: 'root',
})
export class LoginStatusMessageService {
  constructor(private http: HttpClient) {}

  async getLoginStatusMessage(): Promise<void | LoginStatusMessageJson> {
    const response = await this.http
      .get<LoginStatusMessageJson>(
        `${baseUrl}/login-status-message.json?nocache=${new Date().getTime()}`
      )
      .toPromise()
      .catch((err: HttpErrorResponse) => {});
    return response;
  }
}

export type LoginStatusMessageJson = {
  message: string | null;
  link: string | null;
  updated_at: string | null;
};
